<template lang="pug">
  #signUpSuccess
    .container-width.p-3
      .top
      .container-width.p-3
        .bind_icon_wrap.shadow-btn.border-black
          .bind_icon.bind_icon-success

        h1.bind_title
          span 綁定成功!

        .bind_text
          p.text-center MARS BA_ID: 123
          p 請確認MARS BA_ID是否正確。如果錯誤，請洽詢業助。
          p 恭喜您綁定成功，恭喜您綁定成功，恭喜您綁定成功，恭喜您綁定成功，恭喜您綁定成功！

        .btn_wrap
          a.btn.btn-b(@click.stop.prevent="$router.push({ name: 'sa-items-list-index' })")
            span.btn_text 進入我的主頁
</template>

<script>
import okImgUrl from '@/assets/images/icon/icon_ok.png';

export default {
  name: 'saSuccess',
  data() {
    return {
      okImg: okImgUrl
    };
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
  },
  methods: {
    backToLINEHandler() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    }
  }
};
</script>

<style scoped>
  .top {
    background-color: #000 !important;
    width: 100%;
    border-radius: 0 0 1rem 1rem;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    height: 12rem;
  }

  .border-black {
    border: 0.2rem solid #000;
  }

  .shadow-btn {
    -webkit-box-shadow: 0.2rem 0.2rem 0 rgb(0 0 0 / 20%);
    box-shadow: 0.2rem 0.2rem 0 rgb(0 0 0 / 20%);
  }

  .btn {
    border-radius: 9487px;
    font-size: 1rem;
    font-weight: 600;
    display: inline-block;
    text-align: center;
    -webkit-box-shadow: 0.13rem 0.13rem 0 rgb(0 0 0 / 20%);
    box-shadow: 0.13rem 0.13rem 0 rgb(0 0 0 / 20%);
    background-color: $remind !important;
    color: #000 !important;
    border: 0.2rem solid #000;
    cursor: pointer;
  }

  .btn-b {
    width: 100%;
    padding: 0.5rem 0;
  }

  .bind_icon_wrap {
    width: 10rem;
    height: 10rem;
    background-color: #fff;
    border-radius: 50%;
    margin: 1rem auto 1.8rem;
    position: relative;
  }

  .bind_icon {
    width: 7rem;
    height: 0;
    padding-bottom: 7rem;
    background-position: center;
    background-size: cover;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  .bind_icon-fail {
    background-image: url(../../../assets/images/icon/bind-fail.png);
  }

  .bind_icon-success {
    background-image: url(../../../assets/images/icon/bind-success.png);
  }

  .bind_title {
    font-size: 1.6rem;
    font-weight: 800;
    text-align: center;
    margin-bottom: 1.8rem;
  }

  .bind_text {
    font-size: 0.9rem;
    line-height: 1.5;
    font-weight: 500;
    padding: 0 1rem;
    margin-bottom: 1.8rem;
  }

  .btn_wrap {
    margin-bottom: 2.3rem;
  }
</style>
